import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Chart from './views/Chart.vue'
import PasswordReset from './views/PasswordReset.vue'
import Home from './views/Home.vue'
import Timeline from './views/Timeline.vue'
import ProblemReporter from './views/ProblemReporter.vue'
import User from './views/User.vue'
import firebase from '@/firebase-init.js'
import database from '@/api/database.js'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/user',
      name: 'user',
      component: User,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true, requiresAdmin: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/passwordreset',
      name: 'passwordreset',
      component: PasswordReset,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/timeline',
      name: 'timeline',
      component: Timeline,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/problem',
      name: 'problem',
      component: ProblemReporter,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/chart',
      name: 'chart',
      component: Chart,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

database.EventBus.$on('user-auth-state-changed', (user) => {
  if (!user) {
    router.replace('login')
  }
})

// on any navigation event this fires
router.beforeEach((toPath, fromPath, nextStepFunc) => {
  // https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
  
  // create flags based on 'toPath' 
  // requiresAuth == must be signed in
  let requiresAuth = toPath.matched.some(record => record.meta.requiresAuth)
  
  // requiresAdmin == must be Admin user
  let requiresAdmin = toPath.matched.some(record => record.meta.requiresAdmin)
  // database.EventBus.$on('user-auth-state-changed', ((user) => {
  firebase.auth().onAuthStateChanged(async (user) => {
    // should be replaced by user object containing role
    const userAndProfile = await database.getCurrentUserAndProfile()
    const isAdmin = (userAndProfile.profile && ['Admin','ViewAdmin'].indexOf(userAndProfile.profile.role) > -1) ? true : false

    // if the toPath requiresAuth and we are not singed in, go to login
    if (requiresAuth && !user) {
      console.log('next step func login')
      nextStepFunc('login')

    // if the toPath does NOT requireAuth (ie. login ) and we ARE signed in go to timeline?
    } else if (!requiresAuth && user) {
      nextStepFunc('timeline')

    // if the toPath requiresAdmin and user is not Admin, go to Timeline
    } else if (requiresAdmin && !isAdmin) {
      nextStepFunc('timeline')
    
    // if the toPath and user area all good, go to toPath
    } else {
      nextStepFunc()
    }
  })
})
export default router
